// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/analytics_dashboard/:app_group_id/whats_app_credit_consumption_detail_data" endpoint
 */
import { isWhatsAppConsumptionResult } from "@dashboardApi/apis/whatsAppConsumption/validators";

import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { whatsAppConsumption } from "./constants";
import type { WhatsAppConsumptionParams, WhatsAppConsumptionResult } from "./types";

export const getDataTableWhatsAppConsumption = reactQueryTableFetcherAdapter(
  whatsAppConsumption,
  (
    signal: AbortSignal,
    { appGroupId, query, groupby, limit = 20, start = 0, sortdir, sortby }: WhatsAppConsumptionParams
  ): Promise<WhatsAppConsumptionResult> => {
    const { start_date, end_date, waba, app_group: appGroup, category, country, region } = query;

    return fetch(
      `/analytics_dashboard/${appGroupId}/whats_app_credit_consumption_detail_data`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        start_date: start_date,
        end_date: end_date,
        query: serializeQueryObjects({
          ...(waba && { waba: waba }),
          ...(appGroup && { app_group: appGroup }),
          ...(category && { category: category }),
          ...(country && { country: country }),
          ...(region && { region: region }),
        }),
      },
      { signal }
    );
  },
  isWhatsAppConsumptionResult
);
